import lib from '@/library'
import mobileBridge from '@/library/mobileBridge'
import config from '@/config'
import router from '@/router'
import pnmManager from '@/library/payments/pnmManager'

const paymentIDMMSIType = 'PNMVenmo'

const state = {
  isPNMVenmoAvailable: false,
  processing: false,
  depositInstrument: null,
  redirectionURL: null,
  isMobileApp: window.ctsautoconf.MOBILE_LS,
  isAuthServerEnabled: config && config.app && config.app.autoconf && config.app.autoconf.AUTH_SERVER_ENABLED,
  origin: config && config.app && config.app.autoconf && config.app.autoconf.WEB_SERVER_HOSTNAME,
  capacitorIsEnabled: config && config.app && config.app.autoconf && config.app.autoconf.CAPACITOR_ENABLED
}
const getters = {
  isPNMVenmoAvailable () {
    return state.isPNMVenmoAvailable
  },
  processing: () => state.processing,
  redirectionURL: () => state.redirectionURL
}
const mutations = {
  redirectionURL (state, value) {
    state.redirectionURL = value
  },
  setProcessing (state, value) {
    state.processing = value
  }
}
const actions = {
  // part 1: flow to determine if we should display an instument (flag isPNMVenmoAvailable: true or false)
  // instrument will be displayed if allowed and active
  isPNMVenmoAvailable: async (context) => {
    const isAllowed = await context.dispatch('isPNMVenmoAllowed')
    if (!isAllowed) {
      state.isPNMVenmoAvailable = false
    } else {
      const isActive = await context.dispatch('isPNMVenmoActive')
      if (isActive) {
        state.isPNMVenmoAvailable = true
      } else {
        context.dispatch('registerInstrument')
      }
    }
  },
  isPNMVenmoAllowed (context) {
    const allowedPaymentTypes = context.rootGetters['payments/allowedPaymentTypes']
    return allowedPaymentTypes && allowedPaymentTypes.find(type => type.IDMMSIType === paymentIDMMSIType)
  },
  async isPNMVenmoActive (context) {
    // Venmo is deposit-only
    const depositInstrument = await context.dispatch('getActiveInstrument', 'R')
    state.depositInstrument = depositInstrument
    return depositInstrument
  },
  getActiveInstrument: async (context, type) => {
    try {
      const instuments = (type === 'R') ? context.rootGetters['payments/activeRecipientInstuments'] : context.rootGetters['payments/activePaymentInstuments']
      return instuments.find(type => type.IDMMSIType === paymentIDMMSIType)
    } catch (exception) {
      console.log(`Error when trying to fetch a PNMVenmo instrument of type: (${type})`)
    }
  },
  registerInstrument: async (context) => {
    try {
      await lib.rpcService.callBroker('AccountService', 'RegisterRedirectBasedWallet', {'IDMMSIType': paymentIDMMSIType})
      await context.dispatch('payments/initializeActiveInstruments', null, { root: true })
      state.isPNMVenmoAvailable = await context.dispatch('isPNMVenmoActive')
    } catch (exception) {
      console.log(`Error when trying to register a PNMVenmo instrument`)
    }
  },
  // part 1 ends here

  // part 2: redirection
  start: async (context) => {
    state.processing = true
    context.commit('pnmGateway/setInfoMessage', '', { root: true })
    context.commit('pnmGateway/setErrorReference', '', { root: true })
    const IDMMSITXRequest = await context.dispatch('getIDMMSITXRequest')
    if (!IDMMSITXRequest) {
      state.processing = false
      return
    }
    context.commit('pnmGateway/setIDMMSITXRequest', IDMMSITXRequest.result, { root: true })
    let redirectionURL
    try {
      redirectionURL = await lib.rpcService.callBroker('AccountService', 'GetRBWRequest', {
        'IDMMSITXRequest': IDMMSITXRequest.result,
        'returnUrl': '',
        'description': null,
        'language': null
      })
      if (state.isMobileApp && state.capacitorIsEnabled) {
        // if capacitor is enabled [mobile app], open in app browser
        pnmManager.openInAppBrowser(redirectionURL.result.Url, paymentIDMMSIType)
      } else {
        // else keep doing what you've been doing
        context.dispatch('openPNMIFrame', redirectionURL.result.Url)
      }
    } catch (exception) {
      router.push({ name: 'pnm-payment-not-completed' })
      context.commit('pnmGateway/setInfoMessage', exception.message, { root: true })
      context.commit('pnmGateway/setErrorReference', exception.reference, { root: true })
    } finally {
      state.processing = false
    }
  },
  openPNMIFrame: (context, url) => {
    let decoratedUrl = `${url}?return_url=${window.location.href}&pay_url=${window.location.origin}/account/pnm-payment-completed&no_pay_url=${window.location.origin}/account/pnm-payment-not-completed`
    console.log(`[PNM] Redirect to: ${decoratedUrl}`)
    if (state.isMobileApp) {
      // for mobile app, open SFSafariWebController
      mobileBridge.bridgeSendRequest('openPopUpBridge', decoratedUrl)
    } else {
      state.redirectionURL = decoratedUrl
    }
  },
  getIDMMSITXRequest: async () => {
    try {
      const actionMethod = state.isAuthServerEnabled ? 'begindeposit' : 'BeginPaymentTransactionWithoutPassword'
      const IDMMSITXRequest = await lib.rpcService.callBroker('AccountService', actionMethod, {
        'IDMMSIInstruction': state.depositInstrument.IDMMSIInstruction,
        'IDMMSITransactionType': 'M',
        'amount': 0,
        'securityCode': null
      })
      return IDMMSITXRequest
    } catch (exception) {
      state.processing = false
    }
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/payments/PayNearMeGateway/pnmVenmo.js